import {resolveBackground} from '#core/utils/color-utils.js';
import {absoluteUrlToInternalResource} from '#core/utils/url-utils.js';

export function myAccountPageFactory(PALETTE) {
    const MENU_ITEM_STYLE = {
        unselected: {
            style: {
                base: {
                    ...resolveBackground('transparent'),
                    padding: 8,
                    borderWidth: 0,
                    minHeight: 40,
                    ...PALETTE.MY_ACCOUNT_PAGE_MENU_LINK_TEXT,
                },
            },
        },
    };

    return {
        MyAccountPageView: {
            pageHeader: {
                headerContainer: {
                    itemSpacing: 8,
                    style: {
                        padding: '0 8px',
                    },
                },
                icon: {
                    src: 'account',
                    style: {
                        minWidth: 16,
                    },
                },
            },
            menu: {
                width: '220px',
            },
            linkMenu: {
                regularContainer: {
                    style: {...resolveBackground(PALETTE.MY_ACCOUNT_PAGE_CONTAINER_BG)},
                },
                subHeaderContainer: {
                    style: {
                        ...resolveBackground('transparent'),
                        padding: 8,
                        alignItems: 'center',
                        borderStyle: 'solid',
                        borderWidth: '1px 0 0 0',
                        borderColor: PALETTE.MY_ACCOUNT_PAGE_MENU_SECTION_SEPARATOR_COLOR,
                    },
                },
                subHeader: {
                    style: {
                        ...PALETTE.MY_ACCOUNT_PAGE_MENU_HEADER_TEXT,
                    },
                },
                regularItem: MENU_ITEM_STYLE,
                compactItem: MENU_ITEM_STYLE,
                extraItemDetails: {
                    text: '',
                    style: {
                        flex: 'initial',
                        padding: 0,
                        width: 8,
                        height: 8,
                        minWidth: 8,
                        minHeight: 8,
                        margin: '0 0 0 4px',
                        backgroundImage: `url(${absoluteUrlToInternalResource(
                            'images/generic/link-menu-chevron.svg'
                        )})`,
                    },
                },
            },
        },
    };
}
